import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import type { SiteControllerSettingAirHostFormModel } from "@/components/features/settings/site-controller/model/air-host/type";
import type { SiteControllerSettingAirHostFormModelMethodsType } from "@/components/features/settings/site-controller/model/air-host/use-case/use-create-model/methods";

import { SettingsSiteControllerAirHostMainSection } from "./section";
import { SettingsSiteControllerBase } from "../../../_shared/base";

import type { SiteControllerSettingBaseFormModel } from "../../../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../../../model/base/use-case/use-create-model/methods";

type Props = {
	hotelID: string;
	baseViewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;

	airHostViewModel: SiteControllerSettingAirHostFormModel["ViewModel"];
	siteControllerSettingAirHostFormModelMethods: SiteControllerSettingAirHostFormModelMethodsType;

	queryData: SiteControllerSettingBaseFormModel["QueryData"];
};

export const SettingsSiteControllerAirHostBaseInfoIsland = ({
	hotelID,
	baseViewModel,
	siteControllerSettingBaseFormModelMethodsType, //

	airHostViewModel,
	siteControllerSettingAirHostFormModelMethods,
}: Props) => {
	return (
		<FeatureIslandContainer>
			<FeatureIslandMainWithBackGround islandTitle="基本設定">
				<SettingsSiteControllerBase
					hotelID={hotelID}
					siteControllerType={baseViewModel.siteControllerType}
					siteControllerSettingBaseFormModelMethods={siteControllerSettingBaseFormModelMethodsType}
				/>
				<SettingsSiteControllerAirHostMainSection
					airHostViewModel={airHostViewModel}
					siteControllerSettingAirHostFormModelMethods={siteControllerSettingAirHostFormModelMethods}
				/>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

SettingsSiteControllerAirHostBaseInfoIsland.displayName = "SettingsSiteControllerAirHostBaseInfoIsland";
